var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RichTextView',{attrs:{"value":_vm.value,"truncate":_vm.truncate,"headings":false,"compact":true}})}
var staticRenderFns = []

export { render, staticRenderFns }